import { render } from "./LandingPageFantasy.vue?vue&type=template&id=2ff9a1e0&scoped=true"
import script from "./LandingPageFantasy.vue?vue&type=script&lang=js"
export * from "./LandingPageFantasy.vue?vue&type=script&lang=js"

import "./LandingPageFantasy.vue?vue&type=style&index=0&id=2ff9a1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff9a1e0"]])

export default __exports__